var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextBannerLeftArrow = function SvgTextBannerLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "text-banner-left-arrow_svg__a",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(-180 16 16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "text-banner-left-arrow_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#text-banner-left-arrow_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#999",
    mask: "url(#text-banner-left-arrow_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.136 8.8 1.028-1.029L21.392 16l-1.028 1.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.364 14.972 21.392 16l-8.227 8.228-1.03-1.028z"
  })))));
};
export default SvgTextBannerLeftArrow;